<template>
    <AllConsolidatedProductContainer
        :month="selectedMonth"
        :qtypeParam="qtypeParam"
    ></AllConsolidatedProductContainer>
</template>

<script>
import store from '@/store'
import AllConsolidatedProductStore from '@/modules/AllConsolidatedProduct/_store'
import AllConsolidatedProductContainer from '@/modules/AllConsolidatedProduct'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
import useSelectMonth from '@/composables/useSelectMonth'
import { getCurrentInstance } from '@vue/composition-api'
const STORE_KEY = '$_allConsolidatedProduct'
export default {
    components: {
        AllConsolidatedProductContainer
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const {
            selectedGroup,
            selectedProject,
            qtypeParam
        } = useSelectProjectAndGroup()
        const {
            selectedMonth
        } = useSelectMonth()
        store.dispatch(`${STORE_KEY}/fetchAllConsolidatedProducts`, {
            ...qtypeParam.value,
            month: selectedMonth.value
        })
        return {
            qtypeParam,
            selectedGroup,
            selectedProject,
            selectedMonth
        }
    },
    beforeRouteEnter (to, from, next) {
        if (!(STORE_KEY in store._modules.root._children)) {
            store.registerModule(STORE_KEY, AllConsolidatedProductStore)
        }
        if (!from.name) {
            next({ name: 'consolidated' })
        }
        next()
    }
}
</script>

<style>

</style>
